import React from 'react';
import Copy from './copy';

const locale = process.env.REACT_APP_LOCALE;
const copy = Copy[locale] || Copy['en'];

export default (props) => {
  const { now } = props;
  const months = copy.months;
  const hours = now.getHours();
  const datetime =
    now.getDate() +
    ' ' +
    months[now.getMonth()] +
    ' ' +
    now.getFullYear() +
    ', ' +
    (hours > 12 ? hours - 12 : hours) +
    ':' +
    now.getMinutes() +
    ' ' +
    (hours > 12 ? copy.period.pm : copy.period.am);

  return <div className="timestamp">{datetime}</div>;
};
